import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpClient, HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AlertService } from '../_services/alert.service';

@Injectable({
	providedIn: 'root'
})
export class HttpErrorInterceptorService implements HttpInterceptor {

	constructor(
		private alertService: AlertService) { }

	handleError(error: HttpErrorResponse) {
		if(this.alertService)
			this.alertService.error("http error " + error.message);
		else
			alert(error.message);
		return throwError(error);
	}
	intercept(req: HttpRequest<any>, next: HttpHandler):
		Observable<HttpEvent<any>> {
		return next.handle(req)
			.pipe(retry(0),
				catchError(this.handleError)
			)
	};
}
